import axios from "lib/axios";

export const updateDocumentApi = async (data, id) => {
  return await axios.patch(
    `/minutes/buildings/${data.building_id}/documents/${id}`,
    data
  );
};
